/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum LookupSourceType {
  None = 'None',
  Any = 'Any',
  Party = 'Party',
  RelatedParty = 'RelatedParty',
  RelatedPartyRole = 'RelatedPartyRole',
  Person = 'Person',
  ExternalUser = 'ExternalUser',
  Organisation = 'Organisation',
  User = 'User',
  AllUsers = 'AllUsers',
  Team = 'Team',
  RootTeam = 'RootTeam',
  Project = 'Project',
  BookingCentre = 'BookingCentre',
  ServicingCentre = 'ServicingCentre',
  Construct = 'Construct',
  Product = 'Product',
  ProductLine = 'ProductLine',
  ProductRecommendation = 'ProductRecommendation',
  ClientProductAllocation = 'ClientProductAllocation',
  ClientProduct = 'ClientProduct',
  ClientProductFee = 'ClientProductFee',
  ClientProductLive = 'ClientProductLive',
  ClientProductLiveNotClosing = 'ClientProductLiveNotClosing',
  Portfolio = 'Portfolio',
  InvestmentAccount = 'InvestmentAccount',
  BankingAccount = 'BankingAccount',
  InsuranceAccount = 'InsuranceAccount',
  LendingAccount = 'LendingAccount',
  PensionAccount = 'PensionAccount',
  WealthManagementAccount = 'WealthManagementAccount',
  ExternalBankAccount = 'ExternalBankAccount',
  ProductGroup = 'ProductGroup',
  Adviser = 'Adviser',
  Intermediary = 'Intermediary',
  ProductProvider = 'ProductProvider',
  Company = 'Company',
  Charity = 'Charity',
  Trust = 'Trust',
  Collective = 'Collective',
  Corporate = 'Corporate',
  Association = 'Association',
  Foundation = 'Foundation',
  LifeInsuranceWrapper = 'LifeInsuranceWrapper',
  Client = 'Client',
  Case = 'Case',
  Process = 'Process',
  PartyRole = 'PartyRole',
  PartyRoleParty = 'PartyRoleParty',
  PersonPartyRole = 'PersonPartyRole',
  OrganisationPartyRole = 'OrganisationPartyRole',
  Relationship = 'Relationship',
  Opportunity = 'Opportunity',
  Activity = 'Activity',
  WorkItem = 'WorkItem',
  Task = 'Task',
  ExternalTask = 'ExternalTask',
  TimeBooking = 'TimeBooking',
  List = 'List',
  ReportableList = 'ReportableList',
  Campaign = 'Campaign',
  Event = 'Event',
  ContactPoint = 'ContactPoint',
  ElectronicAddress = 'ElectronicAddress',
  PhoneAddress = 'PhoneAddress',
  MobilePhoneAddress = 'MobilePhoneAddress',
  PostalAddress = 'PostalAddress',
  SocialAddress = 'SocialAddress',
  ElectronicBankingAddress = 'ElectronicBankingAddress',
  AddressFinder = 'AddressFinder',
  Assignee = 'Assignee',
  Document = 'Document',
  DocumentTemplate = 'DocumentTemplate',
  DocumentRequirement = 'DocumentRequirement',
  ReportRequest = 'ReportRequest',
  ProjectTemplate = 'ProjectTemplate',
  ProjectTemplateTask = 'ProjectTemplateTask',
  EdsMessageBatch = 'EdsMessageBatch',
  Import = 'Import',
  Envelope = 'Envelope',
  Signatory = 'Signatory',
  Transaction = 'Transaction',
  TransactionEvidence = 'TransactionEvidence',
  AccountHolders = 'AccountHolders',
  ListMemberParty = 'ListMemberParty',
  ListMemberPartyRole = 'ListMemberPartyRole',
  ClientRelationship = 'ClientRelationship',
  ClientRelationshipChild = 'ClientRelationshipChild',
  AmlReport = 'AmlReport',
  Block = 'Block',
  IdentityCheck = 'IdentityCheck',
  Workflow = 'Workflow',
  Article = 'Article',
  WebHook = 'WebHook',
  PersonalRelatedPeople = 'PersonalRelatedPeople'
}
